export { default } from './BasketItem';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/Basket/Contents/BasketItem/index.js